// Date formatting with date-fns (Arabic months spelled in full). A module of its own so that an app's first paint, which loads the i18n
// index, does not carry date-fns and its locales: they load with the screens that format dates.
import { arSA, enGB } from "date-fns/locale";
import { format as dfFormat, formatDistanceToNow } from "date-fns";
import type { Locale } from "./index";

/** Arabic dates always spell the month in full: the abbreviated Arabic month names are clipped with a tatweel ("سبتـ"). */
export function formatDate(date: Date | string | number, locale: Locale, pattern = "d MMM yyyy"): string {
  const d = typeof date === "string" || typeof date === "number" ? new Date(date) : date;
  if (locale !== "ar") return dfFormat(d, pattern, { locale: enGB });
  return dfFormat(d, pattern.replace(/(?<!M)MMM(?!M)/g, "MMMM").replace(/(?<!E)EEE(?!E)/g, "EEEE").replace(/, /g, "، "), { locale: arSA });
}

export function formatDateTime(date: Date | string | number, locale: Locale): string {
  return formatDate(date, locale, "d MMM yyyy, HH:mm");
}

export function formatRelative(date: Date | string | number, locale: Locale): string {
  const d = typeof date === "string" || typeof date === "number" ? new Date(date) : date;
  return formatDistanceToNow(d, { addSuffix: true, locale: locale === "ar" ? arSA : enGB });
}
